/**
 *
 * FBMobileSectionHeader
 *
 */

import React, { useMemo, useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// layout components
import ErrorBoundary from 'engine/ErrorBoundary';

import { getCommunicationTypeLabel } from 'utils/helpers/helper.generateData';

function FBMobileSectionHeader({
  types,
  visibility,
  // default props
  className
}) {
  const { t, i18n } = useTranslation();

  const getLabel = useCallback((type) => getCommunicationTypeLabel(type), [i18n?.language]);

  const render = useMemo(() => (
    <div className={classNames(
      'tcf-fb-mobile-section-header',
      types?.map(el => el),
      className
    )}>
      <div className="header-wrapper">
        {types?.map(type => (
          <div className={`header-tag header-tag--${type}`}>{getLabel(type)?.label}</div>
        ))}
      </div>
    </div>
  ), [types, className, i18n?.language]);

  return (
    <ErrorBoundary>
      {!!visibility && render}
    </ErrorBoundary>
  );
}

FBMobileSectionHeader.defaultProps = {
  types: ['documents'],
  visibility: true
};
export default FBMobileSectionHeader;
